import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from "./rootReducer.js";
import { debounce } from "../utils/debounce.js";
import { volatileState } from "./shopsReducers.js";
import { getCart } from "./cartActions.js";
//import { refreshIfStale } from './refreshIfStale'
import {
  ACTN_REFRESH, SAVE_SELECTEDCAR
} from "./action-types.js"; 

const middleware = [thunk];

//state from localStorage if available
let persistedState = localStorage.getItem('madukaState') ? JSON.parse(localStorage.getItem('madukaState')) : {};
persistedState.shops = { ...persistedState.shops, ...volatileState };

let sessionState = sessionStorage.getItem('madukaState') ? JSON.parse(sessionStorage.getItem('madukaState')) : {};
persistedState = { ...persistedState, ...sessionState};

//console.log("persistedState.cart", persistedState.cart);

const gommeStore = createStore(
  rootReducer,
  persistedState,
  applyMiddleware(...middleware)
)

export default gommeStore;

var updateLocalStorage = debounce(() => {
  var state = gommeStore.getState();
  //if (state.cart.cart.wheels && state.cart.cart.wheels.length) {
  //  console.log("updateLocalStorage", state.cart.cart.wheels.length);
  //} else {
  //  console.log("updateLocalStorage", state.cart.cart.wheels);
  //}
  localStorage.setItem('madukaState', JSON.stringify({ ...state, shared: undefined }))
  sessionStorage.setItem('madukaState', JSON.stringify({ shared: state.shared }))
}, 100);

gommeStore.subscribe(() => {
  updateLocalStorage();
})

gommeStore
  .dispatch(getCart());

// if (window.state) {
if (window.state) {
  gommeStore
    .dispatch({
      type: ACTN_REFRESH,
      data: { ...window.state }
    });
  //if (window.state.user) {
  //  store
  //    .dispatch(initPusher());
  //  store
  //    .dispatch(refreshIfStale());
  //}
}

if (window.globalData && window.globalData) {
  gommeStore
    .dispatch({
      type: ACTN_REFRESH,
      data: { ...window.globalData }
    });
}

//gommeStore
//  .dispatch(refreshIfStale());


